import {
  HttpMethod,
  HttpRequestBody,
  HttpResponseType,
  HttpHeaders,
  HttpRequest
} from './interfaces';
import { HttpRequestCredentials } from '@kollective-frontend/ksdk-api';
import Timer from './Timer';

export interface MakeRequestOptions {
  body?: HttpRequestBody;
  headers?: HttpHeaders;
  responseType?: HttpResponseType;
  withCredentials?: boolean;
  creds?: HttpRequestCredentials;
  timeout?: number;
}

const getTimeout = (timeout?: unknown) => {
  if (typeof timeout === 'string') {
    timeout = parseInt(timeout);
  }
  if (typeof timeout !== 'number' || Number.isNaN(timeout)) {
    return 0;
  }
  return Math.max(0, timeout);
};

export default function makeRequest(
  method: HttpMethod,
  url: string,
  opts?: MakeRequestOptions
): HttpRequest {
  const { timeout, headers, body, responseType } = opts ?? {};
  const credentials = getCredentialsString(opts);

  return {
    method,
    url,
    body,
    credentials,
    headers: headers || new Map(),
    responseType,
    timeout: 0,
    originTimeout: getTimeout(timeout),
    timer: new Timer(),
    initTime: Date.now()
  };
}

export const getCredentialsString = (
  opts?: MakeRequestOptions
): HttpRequestCredentials => {
  if (!opts) {
    return 'same-origin';
  }
  return opts.creds || opts.withCredentials ? 'include' : 'same-origin';
};
